export const AxeOptions =
    [
        {
            "key": "EMPTY",
            "text": "",
            "value": ""
        },
        {
            "key": 38,
            "text": "0º",
            "value": "0º"
        },
        {
            "key": 39,
            "text": "1º",
            "value": "1º"
        },
        {
            "key": 40,
            "text": "2º",
            "value": "2º"
        },
        {
            "key": 41,
            "text": "3º",
            "value": "3º"
        },
        {
            "key": 42,
            "text": "4º",
            "value": "4º"
        },
        {
            "key": 43,
            "text": "5º",
            "value": "5º"
        },
        {
            "key": 44,
            "text": "6º",
            "value": "6º"
        },
        {
            "key": 45,
            "text": "7º",
            "value": "7º"
        },
        {
            "key": 46,
            "text": "8º",
            "value": "8º"
        },
        {
            "key": 47,
            "text": "9º",
            "value": "9º"
        },
        {
            "key": 48,
            "text": "10º",
            "value": "10º"
        },
        {
            "key": 49,
            "text": "11º",
            "value": "11º"
        },
        {
            "key": 50,
            "text": "12º",
            "value": "12º"
        },
        {
            "key": 51,
            "text": "13º",
            "value": "13º"
        },
        {
            "key": 52,
            "text": "14º",
            "value": "14º"
        },
        {
            "key": 53,
            "text": "15º",
            "value": "15º"
        },
        {
            "key": 54,
            "text": "16º",
            "value": "16º"
        },
        {
            "key": 55,
            "text": "17º",
            "value": "17º"
        },
        {
            "key": 56,
            "text": "18º",
            "value": "18º"
        },
        {
            "key": 57,
            "text": "19º",
            "value": "19º"
        },
        {
            "key": 58,
            "text": "20º",
            "value": "20º"
        },
        {
            "key": 59,
            "text": "21º",
            "value": "21º"
        },
        {
            "key": 60,
            "text": "22º",
            "value": "22º"
        },
        {
            "key": 61,
            "text": "23º",
            "value": "23º"
        },
        {
            "key": 62,
            "text": "24º",
            "value": "24º"
        },
        {
            "key": 63,
            "text": "25º",
            "value": "25º"
        },
        {
            "key": 64,
            "text": "26º",
            "value": "26º"
        },
        {
            "key": 65,
            "text": "27º",
            "value": "27º"
        },
        {
            "key": 66,
            "text": "28º",
            "value": "28º"
        },
        {
            "key": 67,
            "text": "29º",
            "value": "29º"
        },
        {
            "key": 68,
            "text": "30º",
            "value": "30º"
        },
        {
            "key": 69,
            "text": "31º",
            "value": "31º"
        },
        {
            "key": 70,
            "text": "32º",
            "value": "32º"
        },
        {
            "key": 71,
            "text": "33º",
            "value": "33º"
        },
        {
            "key": 72,
            "text": "34º",
            "value": "34º"
        },
        {
            "key": 73,
            "text": "35º",
            "value": "35º"
        },
        {
            "key": 74,
            "text": "36º",
            "value": "36º"
        },
        {
            "key": 75,
            "text": "37º",
            "value": "37º"
        },
        {
            "key": 76,
            "text": "38º",
            "value": "38º"
        },
        {
            "key": 77,
            "text": "39º",
            "value": "39º"
        },
        {
            "key": 78,
            "text": "40º",
            "value": "40º"
        },
        {
            "key": 79,
            "text": "41º",
            "value": "41º"
        },
        {
            "key": 80,
            "text": "42º",
            "value": "42º"
        },
        {
            "key": 81,
            "text": "43º",
            "value": "43º"
        },
        {
            "key": 82,
            "text": "44º",
            "value": "44º"
        },
        {
            "key": 83,
            "text": "45º",
            "value": "45º"
        },
        {
            "key": 84,
            "text": "46º",
            "value": "46º"
        },
        {
            "key": 85,
            "text": "47º",
            "value": "47º"
        },
        {
            "key": 86,
            "text": "48º",
            "value": "48º"
        },
        {
            "key": 87,
            "text": "49º",
            "value": "49º"
        },
        {
            "key": 88,
            "text": "50º",
            "value": "50º"
        },
        {
            "key": 89,
            "text": "51º",
            "value": "51º"
        },
        {
            "key": 90,
            "text": "52º",
            "value": "52º"
        },
        {
            "key": 91,
            "text": "53º",
            "value": "53º"
        },
        {
            "key": 92,
            "text": "54º",
            "value": "54º"
        },
        {
            "key": 93,
            "text": "55º",
            "value": "55º"
        },
        {
            "key": 94,
            "text": "56º",
            "value": "56º"
        },
        {
            "key": 95,
            "text": "57º",
            "value": "57º"
        },
        {
            "key": 96,
            "text": "58º",
            "value": "58º"
        },
        {
            "key": 97,
            "text": "59º",
            "value": "59º"
        },
        {
            "key": 98,
            "text": "60º",
            "value": "60º"
        },
        {
            "key": 99,
            "text": "61º",
            "value": "61º"
        },
        {
            "key": 100,
            "text": "62º",
            "value": "62º"
        },
        {
            "key": 101,
            "text": "63º",
            "value": "63º"
        },
        {
            "key": 102,
            "text": "64º",
            "value": "64º"
        },
        {
            "key": 103,
            "text": "65º",
            "value": "65º"
        },
        {
            "key": 104,
            "text": "66º",
            "value": "66º"
        },
        {
            "key": 105,
            "text": "67º",
            "value": "67º"
        },
        {
            "key": 106,
            "text": "68º",
            "value": "68º"
        },
        {
            "key": 107,
            "text": "69º",
            "value": "69º"
        },
        {
            "key": 108,
            "text": "70º",
            "value": "70º"
        },
        {
            "key": 109,
            "text": "71º",
            "value": "71º"
        },
        {
            "key": 110,
            "text": "72º",
            "value": "72º"
        },
        {
            "key": 111,
            "text": "73º",
            "value": "73º"
        },
        {
            "key": 112,
            "text": "74º",
            "value": "74º"
        },
        {
            "key": 113,
            "text": "75º",
            "value": "75º"
        },
        {
            "key": 114,
            "text": "76º",
            "value": "76º"
        },
        {
            "key": 115,
            "text": "77º",
            "value": "77º"
        },
        {
            "key": 116,
            "text": "78º",
            "value": "78º"
        },
        {
            "key": 117,
            "text": "79º",
            "value": "79º"
        },
        {
            "key": 118,
            "text": "80º",
            "value": "80º"
        },
        {
            "key": 119,
            "text": "81º",
            "value": "81º"
        },
        {
            "key": 120,
            "text": "82º",
            "value": "82º"
        },
        {
            "key": 121,
            "text": "83º",
            "value": "83º"
        },
        {
            "key": 122,
            "text": "84º",
            "value": "84º"
        },
        {
            "key": 123,
            "text": "85º",
            "value": "85º"
        },
        {
            "key": 124,
            "text": "86º",
            "value": "86º"
        },
        {
            "key": 125,
            "text": "87º",
            "value": "87º"
        },
        {
            "key": 126,
            "text": "88º",
            "value": "88º"
        },
        {
            "key": 127,
            "text": "89º",
            "value": "89º"
        },
        {
            "key": 128,
            "text": "90º",
            "value": "90º"
        },
        {
            "key": 129,
            "text": "91º",
            "value": "91º"
        },
        {
            "key": 130,
            "text": "92º",
            "value": "92º"
        },
        {
            "key": 131,
            "text": "93º",
            "value": "93º"
        },
        {
            "key": 132,
            "text": "94º",
            "value": "94º"
        },
        {
            "key": 133,
            "text": "95º",
            "value": "95º"
        },
        {
            "key": 134,
            "text": "96º",
            "value": "96º"
        },
        {
            "key": 135,
            "text": "97º",
            "value": "97º"
        },
        {
            "key": 136,
            "text": "98º",
            "value": "98º"
        },
        {
            "key": 137,
            "text": "99º",
            "value": "99º"
        },
        {
            "key": 138,
            "text": "100º",
            "value": "100º"
        },
        {
            "key": 139,
            "text": "101º",
            "value": "101º"
        },
        {
            "key": 140,
            "text": "102º",
            "value": "102º"
        },
        {
            "key": 141,
            "text": "103º",
            "value": "103º"
        },
        {
            "key": 142,
            "text": "104º",
            "value": "104º"
        },
        {
            "key": 143,
            "text": "105º",
            "value": "105º"
        },
        {
            "key": 144,
            "text": "106º",
            "value": "106º"
        },
        {
            "key": 145,
            "text": "107º",
            "value": "107º"
        },
        {
            "key": 146,
            "text": "108º",
            "value": "108º"
        },
        {
            "key": 147,
            "text": "109º",
            "value": "109º"
        },
        {
            "key": 148,
            "text": "110º",
            "value": "110º"
        },
        {
            "key": 149,
            "text": "111º",
            "value": "111º"
        },
        {
            "key": 150,
            "text": "112º",
            "value": "112º"
        },
        {
            "key": 151,
            "text": "113º",
            "value": "113º"
        },
        {
            "key": 152,
            "text": "114º",
            "value": "114º"
        },
        {
            "key": 153,
            "text": "115º",
            "value": "115º"
        },
        {
            "key": 154,
            "text": "116º",
            "value": "116º"
        },
        {
            "key": 155,
            "text": "117º",
            "value": "117º"
        },
        {
            "key": 156,
            "text": "118º",
            "value": "118º"
        },
        {
            "key": 157,
            "text": "119º",
            "value": "119º"
        },
        {
            "key": 158,
            "text": "120º",
            "value": "120º"
        },
        {
            "key": 159,
            "text": "121º",
            "value": "121º"
        },
        {
            "key": 160,
            "text": "122º",
            "value": "122º"
        },
        {
            "key": 161,
            "text": "123º",
            "value": "123º"
        },
        {
            "key": 162,
            "text": "124º",
            "value": "124º"
        },
        {
            "key": 163,
            "text": "125º",
            "value": "125º"
        },
        {
            "key": 164,
            "text": "126º",
            "value": "126º"
        },
        {
            "key": 165,
            "text": "127º",
            "value": "127º"
        },
        {
            "key": 166,
            "text": "128º",
            "value": "128º"
        },
        {
            "key": 167,
            "text": "129º",
            "value": "129º"
        },
        {
            "key": 168,
            "text": "130º",
            "value": "130º"
        },
        {
            "key": 169,
            "text": "131º",
            "value": "131º"
        },
        {
            "key": 170,
            "text": "132º",
            "value": "132º"
        },
        {
            "key": 171,
            "text": "133º",
            "value": "133º"
        },
        {
            "key": 172,
            "text": "134º",
            "value": "134º"
        },
        {
            "key": 173,
            "text": "135º",
            "value": "135º"
        },
        {
            "key": 174,
            "text": "136º",
            "value": "136º"
        },
        {
            "key": 175,
            "text": "137º",
            "value": "137º"
        },
        {
            "key": 176,
            "text": "138º",
            "value": "138º"
        },
        {
            "key": 177,
            "text": "139º",
            "value": "139º"
        },
        {
            "key": 178,
            "text": "140º",
            "value": "140º"
        },
        {
            "key": 179,
            "text": "141º",
            "value": "141º"
        },
        {
            "key": 180,
            "text": "142º",
            "value": "142º"
        },
        {
            "key": 181,
            "text": "143º",
            "value": "143º"
        },
        {
            "key": 182,
            "text": "144º",
            "value": "144º"
        },
        {
            "key": 183,
            "text": "145º",
            "value": "145º"
        },
        {
            "key": 184,
            "text": "146º",
            "value": "146º"
        },
        {
            "key": 185,
            "text": "147º",
            "value": "147º"
        },
        {
            "key": 186,
            "text": "148º",
            "value": "148º"
        },
        {
            "key": 187,
            "text": "149º",
            "value": "149º"
        },
        {
            "key": 188,
            "text": "150º",
            "value": "150º"
        },
        {
            "key": 189,
            "text": "151º",
            "value": "151º"
        },
        {
            "key": 190,
            "text": "152º",
            "value": "152º"
        },
        {
            "key": 191,
            "text": "153º",
            "value": "153º"
        },
        {
            "key": 192,
            "text": "154º",
            "value": "154º"
        },
        {
            "key": 193,
            "text": "155º",
            "value": "155º"
        },
        {
            "key": 194,
            "text": "156º",
            "value": "156º"
        },
        {
            "key": 195,
            "text": "157º",
            "value": "157º"
        },
        {
            "key": 196,
            "text": "158º",
            "value": "158º"
        },
        {
            "key": 197,
            "text": "159º",
            "value": "159º"
        },
        {
            "key": 198,
            "text": "160º",
            "value": "160º"
        },
        {
            "key": 199,
            "text": "161º",
            "value": "161º"
        },
        {
            "key": 200,
            "text": "162º",
            "value": "162º"
        },
        {
            "key": 201,
            "text": "163º",
            "value": "163º"
        },
        {
            "key": 202,
            "text": "164º",
            "value": "164º"
        },
        {
            "key": 203,
            "text": "165º",
            "value": "165º"
        },
        {
            "key": 204,
            "text": "166º",
            "value": "166º"
        },
        {
            "key": 205,
            "text": "167º",
            "value": "167º"
        },
        {
            "key": 206,
            "text": "168º",
            "value": "168º"
        },
        {
            "key": 207,
            "text": "169º",
            "value": "169º"
        },
        {
            "key": 208,
            "text": "170º",
            "value": "170º"
        },
        {
            "key": 209,
            "text": "171º",
            "value": "171º"
        },
        {
            "key": 210,
            "text": "172º",
            "value": "172º"
        },
        {
            "key": 211,
            "text": "173º",
            "value": "173º"
        },
        {
            "key": 212,
            "text": "174º",
            "value": "174º"
        },
        {
            "key": 213,
            "text": "175º",
            "value": "175º"
        },
        {
            "key": 214,
            "text": "176º",
            "value": "176º"
        },
        {
            "key": 215,
            "text": "177º",
            "value": "177º"
        },
        {
            "key": 216,
            "text": "178º",
            "value": "178º"
        },
        {
            "key": 217,
            "text": "179º",
            "value": "179º"
        },
        {
            "key": 218,
            "text": "180º",
            "value": "180º"
        }
    ]